export default "__VITE_ASSET__BDi$b1sR__"